// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Codec from "../Data.Codec/index.js";
import * as Data_Codec_Argonaut from "../Data.Codec.Argonaut/index.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var map = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var toCodecError = function (v) {
    if (v instanceof Data_Argonaut_Decode_Error.TypeMismatch) {
        return new Data_Codec_Argonaut.TypeMismatch(v.value0);
    };
    if (v instanceof Data_Argonaut_Decode_Error.UnexpectedValue) {
        return new Data_Codec_Argonaut.UnexpectedValue(v.value0);
    };
    if (v instanceof Data_Argonaut_Decode_Error.AtIndex) {
        return new Data_Codec_Argonaut.AtIndex(v.value0, toCodecError(v.value1));
    };
    if (v instanceof Data_Argonaut_Decode_Error.AtKey) {
        return new Data_Codec_Argonaut.AtKey(v.value0, toCodecError(v.value1));
    };
    if (v instanceof Data_Argonaut_Decode_Error.Named) {
        return new Data_Codec_Argonaut.Named(v.value0, toCodecError(v.value1));
    };
    if (v instanceof Data_Argonaut_Decode_Error.MissingValue) {
        return Data_Codec_Argonaut.MissingValue.value;
    };
    throw new Error("Failed pattern match at Fusion.Util (line 45, column 16 - line 51, column 36): " + [ v.constructor.name ]);
};
var padEnd = /* #__PURE__ */ Data_Function_Uncurried.runFn3($foreign.padEndImpl);
var liftEitherErr = function (dictMonadError) {
    var liftEither = Control_Monad_Error_Class.liftEither(dictMonadError.MonadThrow0());
    return function (mapErr) {
        var $40 = lmap(mapErr);
        return function ($41) {
            return liftEither($40($41));
        };
    };
};
var liftAffErr = function (dictMonadError) {
    var liftEither = Control_Monad_Error_Class.liftEither(dictMonadError.MonadThrow0());
    return function (dictMonadAff) {
        var bind = Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1());
        var liftAff = Effect_Aff_Class.liftAff(dictMonadAff);
        return function (mapErr) {
            return function (io) {
                return bind(liftAff(map(lmap(mapErr))(io)))(liftEither);
            };
        };
    };
};
var jsonCodec = function (dictDecodeJson) {
    var decodeJson = Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson);
    return function (dictEncodeJson) {
        return Data_Codec["codec$prime"](map1(lmap(toCodecError))(decodeJson))(Data_Argonaut_Encode_Class.encodeJson(dictEncodeJson));
    };
};
var fromCodecError = function (v) {
    if (v instanceof Data_Codec_Argonaut.TypeMismatch) {
        return new Data_Argonaut_Decode_Error.TypeMismatch(v.value0);
    };
    if (v instanceof Data_Codec_Argonaut.UnexpectedValue) {
        return new Data_Argonaut_Decode_Error.UnexpectedValue(v.value0);
    };
    if (v instanceof Data_Codec_Argonaut.AtIndex) {
        return new Data_Argonaut_Decode_Error.AtIndex(v.value0, fromCodecError(v.value1));
    };
    if (v instanceof Data_Codec_Argonaut.AtKey) {
        return new Data_Argonaut_Decode_Error.AtKey(v.value0, fromCodecError(v.value1));
    };
    if (v instanceof Data_Codec_Argonaut.Named) {
        return new Data_Argonaut_Decode_Error.Named(v.value0, fromCodecError(v.value1));
    };
    if (v instanceof Data_Codec_Argonaut.MissingValue) {
        return Data_Argonaut_Decode_Error.MissingValue.value;
    };
    throw new Error("Failed pattern match at Fusion.Util (line 54, column 18 - line 60, column 36): " + [ v.constructor.name ]);
};
export {
    jsonCodec,
    liftAffErr,
    liftEitherErr,
    fromCodecError,
    padEnd
};
